var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkthemeHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#222734"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5263 42.5253C25.1333 42.5253 24 41.392 24 39.999C24 38.6059 25.1333 37.4727 26.5263 37.4727H53.4737C54.8668 37.4727 56 38.6059 56 39.999C56 41.392 54.8668 42.5253 53.4737 42.5253H26.5263Z",
    fill: "#95A4C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5263 30.7362C25.1333 30.7362 24 29.603 24 28.2099C24 26.8168 25.1333 25.6836 26.5263 25.6836H53.4737C54.8668 25.6836 56 26.8168 56 28.2099C56 29.603 54.8668 30.7362 53.4737 30.7362H26.5263Z",
    fill: "#95A4C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5263 54.3143C25.1333 54.3143 24 53.1811 24 51.788C24 50.395 25.1333 49.2617 26.5263 49.2617H53.4737C54.8668 49.2617 56 50.395 56 51.788C56 53.1811 54.8668 54.3143 53.4737 54.3143H26.5263Z",
    fill: "#95A4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkthemeHamburger);
export default __webpack_public_path__ + "static/media/darkthemeHamburger.0981643e981159c9865dfda84828cb1f.svg";
export { ForwardRef as ReactComponent };